// Mock accommodations data
export const accommodations = [
  {
    id: 1,
    title: 'Canal House with Water View',
    description:
      'Authentic Amsterdam canal house with beautiful water views. Renovated interior with traditional Dutch elements.',
    price: 165,
    rating: 4.8,
    location: 'Jordaan, Amsterdam',
    image:
      'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    lat: 52.370216,
    lng: 4.895168,
  },
  {
    id: 2,
    title: 'Cozy Apartment on Prinsengracht',
    description:
      'Charming apartment overlooking the famous Prinsengracht canal. Walking distance to Anne Frank House and boutique shops.',
    price: 135,
    rating: 4.6,
    location: 'Grachtengordel, Amsterdam',
    image:
      'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    lat: 52.366697,
    lng: 4.891345,
  },
  {
    id: 3,
    title: 'Modern Houseboat on Amstel River',
    description:
      "Unique living experience on a renovated houseboat. All modern amenities with the charm of living on Amsterdam's waterways.",
    price: 210,
    rating: 4.9,
    location: 'Amstel, Amsterdam',
    image:
      'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2080&q=80',
    lat: 52.374716,
    lng: 4.889168,
  },
  {
    id: 4,
    title: 'Historic Townhouse with Garden',
    description:
      '17th century townhouse with private garden. Fully restored with period features and modern comforts.',
    price: 225,
    rating: 4.7,
    location: 'De Pijp, Amsterdam',
    image:
      'https://images.unsplash.com/photo-1484154218962-a197022b5858?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2074&q=80',
    lat: 52.368716,
    lng: 4.882168,
  },
  {
    id: 5,
    title: 'Trendy Loft in Former Warehouse',
    description:
      'Industrial-style loft in converted dockland warehouse. High ceilings, original features, and stunning city views.',
    price: 180,
    rating: 4.5,
    location: 'NDSM, Amsterdam North',
    image:
      'https://images.unsplash.com/photo-1554995207-c18c203602cb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    lat: 52.362716,
    lng: 4.885168,
  },
  {
    id: 6,
    title: 'Boutique Apartment Near Vondelpark',
    description:
      "Stylish apartment just steps from Amsterdam's famous Vondelpark. Perfect for couples who enjoy nature and city life.",
    price: 155,
    rating: 4.7,
    location: 'Oud-West, Amsterdam',
    image:
      'https://images.unsplash.com/photo-1536376072261-38c75010e6c9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2071&q=80',
    lat: 52.361716,
    lng: 4.878168,
  },
]

// Mock POI categories and data
export const poiCategories = [
  {
    type: 'supermarket',
    label: 'Supermarkets',
    icon: 'https://cdn-icons-png.flaticon.com/512/3081/3081559.png',
    items: [
      { name: 'Albert Heijn', lat: 52.369716, lng: 4.894168 },
      { name: 'Jumbo', lat: 52.371216, lng: 4.888168 },
      { name: 'Lidl', lat: 52.366216, lng: 4.892168 },
      { name: 'Dirk van den Broek', lat: 52.367516, lng: 4.893568 },
      { name: 'Marqt', lat: 52.365216, lng: 4.891768 },
    ],
  },
  {
    type: 'attraction',
    label: 'Attractions',
    icon: 'https://cdn-icons-png.flaticon.com/512/3030/3030511.png',
    items: [
      { name: 'Rijksmuseum', lat: 52.360216, lng: 4.885168 },
      { name: 'Anne Frank House', lat: 52.375216, lng: 4.884168 },
      { name: 'Van Gogh Museum', lat: 52.358216, lng: 4.881168 },
      { name: 'Royal Palace Amsterdam', lat: 52.373613, lng: 4.891714 },
      { name: 'NEMO Science Museum', lat: 52.374064, lng: 4.912226 },
      { name: 'Heineken Experience', lat: 52.357795, lng: 4.891868 },
    ],
  },
  {
    type: 'pharmacy',
    label: 'Pharmacies',
    icon: 'https://cdn-icons-png.flaticon.com/512/2966/2966327.png',
    items: [
      { name: 'City Pharmacy', lat: 52.368216, lng: 4.896168 },
      { name: 'Health Center Pharmacy', lat: 52.372216, lng: 4.891168 },
      { name: 'Apotheek Vredenburg', lat: 52.369516, lng: 4.893268 },
      { name: 'BENU Apotheek', lat: 52.371816, lng: 4.887768 },
    ],
  },
  {
    type: 'restaurant',
    label: 'Restaurants',
    icon: 'https://cdn-icons-png.flaticon.com/512/562/562678.png',
    items: [
      { name: 'De Silveren Spiegel', lat: 52.373216, lng: 4.893168 },
      { name: 'Foodhallen', lat: 52.367216, lng: 4.878168 },
      { name: 'Restaurant Greetje', lat: 52.371216, lng: 4.898168 },
      { name: 'Moeders', lat: 52.371716, lng: 4.883468 },
      { name: 'Pancakes Amsterdam', lat: 52.375716, lng: 4.889768 },
      { name: 'Rijsel', lat: 52.359516, lng: 4.917268 },
      { name: 'Cannibale Royale', lat: 52.368316, lng: 4.891568 },
    ],
  },
  {
    type: 'bar',
    label: 'Bars & Nightlife',
    icon: 'https://cdn-icons-png.flaticon.com/512/2739/2739785.png',
    items: [
      { name: "Brouwerij 't IJ", lat: 52.366216, lng: 4.901168 },
      { name: 'Tales & Spirits', lat: 52.374216, lng: 4.889168 },
      { name: 'Door 74', lat: 52.369216, lng: 4.895168 },
      { name: 'Wynand Fockink', lat: 52.372516, lng: 4.894768 },
      { name: 'Bar Oldenhof', lat: 52.371116, lng: 4.877568 },
      { name: 'Proeflokaal Arendsnest', lat: 52.376716, lng: 4.887968 },
    ],
  },
  {
    type: 'transport',
    label: 'Public Transport',
    icon: 'https://cdn-icons-png.flaticon.com/512/3448/3448339.png',
    items: [
      { name: 'Amsterdam Centraal Station', lat: 52.378056, lng: 4.900278 },
      { name: 'Leidseplein Tram Stop', lat: 52.363889, lng: 4.883333 },
      { name: 'Dam Square Tram Stop', lat: 52.373056, lng: 4.893056 },
      { name: 'Nieuwmarkt Metro Station', lat: 52.373333, lng: 4.900278 },
      { name: 'Weesperplein Metro Station', lat: 52.363611, lng: 4.907778 },
      { name: 'Amsterdam Zuid Station', lat: 52.338889, lng: 4.872778 },
    ],
  },
  {
    type: 'park',
    label: 'Parks & Recreation',
    icon: 'https://cdn-icons-png.flaticon.com/512/1906/1906827.png',
    items: [
      { name: 'Vondelpark', lat: 52.358056, lng: 4.868333 },
      { name: 'Oosterpark', lat: 52.360556, lng: 4.921944 },
      { name: 'Westerpark', lat: 52.386667, lng: 4.878056 },
      { name: 'Sarphatipark', lat: 52.356111, lng: 4.895833 },
      { name: 'Amstelpark', lat: 52.328889, lng: 4.890556 },
    ],
  },
  {
    type: 'coffeeshop',
    label: 'Coffee Shops',
    icon: 'https://cdn-icons-png.flaticon.com/512/1047/1047503.png',
    items: [
      { name: 'Bulldog', lat: 52.372222, lng: 4.890278 },
      { name: 'Greenhouse', lat: 52.371944, lng: 4.896111 },
      { name: 'Grey Area', lat: 52.376389, lng: 4.883611 },
      { name: 'Paradox', lat: 52.371389, lng: 4.879444 },
      { name: "Barney's", lat: 52.375833, lng: 4.888611 },
    ],
  },
  {
    type: 'museum',
    label: 'Museums',
    icon: 'https://cdn-icons-png.flaticon.com/512/3659/3659882.png',
    items: [
      { name: 'Rijksmuseum', lat: 52.360216, lng: 4.885168 },
      { name: 'Van Gogh Museum', lat: 52.358216, lng: 4.881168 },
      { name: 'Stedelijk Museum', lat: 52.357778, lng: 4.879722 },
      { name: 'Amsterdam Museum', lat: 52.37, lng: 4.886944 },
      { name: 'Hermitage Amsterdam', lat: 52.365556, lng: 4.903333 },
      { name: 'Moco Museum', lat: 52.358333, lng: 4.882778 },
      { name: 'FOAM Photography Museum', lat: 52.364167, lng: 4.8925 },
    ],
  },
  {
    type: 'shopping',
    label: 'Shopping',
    icon: 'https://cdn-icons-png.flaticon.com/512/3144/3144456.png',
    items: [
      { name: 'Kalverstraat', lat: 52.371111, lng: 4.890278 },
      { name: 'De Bijenkorf', lat: 52.373889, lng: 4.895 },
      { name: 'PC Hooftstraat', lat: 52.361389, lng: 4.879722 },
      { name: 'Albert Cuyp Market', lat: 52.356111, lng: 4.893889 },
      { name: 'Nine Streets (Negen Straatjes)', lat: 52.369444, lng: 4.885278 },
      { name: 'Utrechtsestraat', lat: 52.366111, lng: 4.896667 },
    ],
  },
]
